import { useMsal } from '@azure/msal-react';
import './Header.css';

function Header() {
  const { instance, accounts } = useMsal();

  const handleLogout = () => {
    instance.logoutPopup();
  };

  const userEmail = accounts[0]?.username || 'User';

  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title">Ephemeral Environment Manager</h1>
        <div className="header-user">
          <span className="user-email">{userEmail}</span>
          <button onClick={handleLogout} className="logout-button">
            Sign Out
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
